import { FC } from "react";
import { Redeem } from "@mui/icons-material";

import { useApiCall } from "@dzambalaorg/react-hooks";
import { useMetamask, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import { ListAction, ListActionVariant } from "@framework/styled";
import { AddressType, IWaitListItem } from "@framework/types";
import WaitListClaimABI from "@framework/abis/json/WaitList/claim.json";

export interface IWaitListClaimButtonProps {
  className?: string;
  disabled?: boolean;
  listItem: Partial<IWaitListItem>;
  variant?: ListActionVariant;
}

export const WaitListClaimButton: FC<IWaitListClaimButtonProps> = props => {
  const { className, disabled, listItem, variant } = props;
  const { listId, list } = listItem;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const { fn } = useApiCall(
    async (api, listId) => {
      return api.fetchJson({
        url: `/wait-list/item/proof`,
        method: "POST",
        data: {
          listId,
        },
      });
    },
    { success: false },
  );

  const { execute: metaWaitList } = useMetamask(async () => {
    return fn(null as unknown as any, listId).then((proof: { proof: Array<string> }) => {
      return writeContractAsync({
        address: list!.contract.address as AddressType,
        abi: WaitListClaimABI,
        functionName: "claim",
        args: [proof.proof, listId],
      });
    });
  });

  const handleClick = () => {
    return metaWaitList();
  };

  return (
    <ListAction
      onClick={handleClick}
      icon={Redeem}
      message="form.tips.claim"
      className={className}
      dataTestId="ClaimWaitListButton"
      disabled={disabled}
      variant={variant}
    />
  );
};
